import { matchPath } from 'react-router-dom';
import { PORTAL_ROUTE_PREFIX } from '../../constants/values';
export var isOnAdminRoute = function (pathName) {
    return pathName.startsWith(PORTAL_ROUTE_PREFIX + "/admin/");
};
export var isOnRedirectPageRoute = function (pathName) {
    return pathName.startsWith(PORTAL_ROUTE_PREFIX + "/redirect-to");
};
export var isOnJoinPage = function (pathname) {
    return (isOnGenericJoinPage(pathname) ||
        isOnJoinPageWithPendingTeamMemberId(pathname));
};
export var isOnGenericJoinPage = function (pathname) {
    return matchPath(pathname, {
        path: PORTAL_ROUTE_PREFIX + "/join",
        exact: true,
        strict: false,
    });
};
export var isOnJoinPageWithPendingTeamMemberId = function (pathname) {
    return matchPath(pathname, {
        path: PORTAL_ROUTE_PREFIX + "/join/:pendingTeamMemberId",
        exact: true,
        strict: false,
    });
};
export var getPendingTeamMemberIdFromUrl = function (pathname) {
    var joinUrlWithSlash = PORTAL_ROUTE_PREFIX + "/join/";
    return pathname.startsWith(joinUrlWithSlash)
        ? pathname.replace(joinUrlWithSlash, '')
        : '';
};
